export const NAME = "Emily Gamarro";
export const contactInfo = {
    completePhone: "+50259597853",
    phone: "59597853",
    domain: "emgamarropsicologia.com",
    email: "emgamarro.psicologia@gmail.com"
}

export const gform = "https://docs.google.com/forms/d/e/1FAIpQLSdtmB_cZmgqBMaU1AWHbUO8ugRpH-FkYg1G9-wAJbLPSe8fhQ/formResponse";